module.exports = __webpack_public_path__ + "static/media/demo3.5e725b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/demo3.png
// module id = 323
// module chunks = 0